import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends ComponentProps<'input'> {
  /** Renders the field in an error state and links it to the message for a11y. */
  invalid?: boolean;
}

export function Input({ className, invalid = false, ...props }: InputProps) {
  return (
    <input
      aria-invalid={invalid || undefined}
      className={cn(
        'flex h-11 w-full rounded-lg border bg-background px-3 py-2 text-sm',
        'placeholder:text-muted-foreground/70',
        'transition-[border-color,box-shadow] duration-150',
        'outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/40',
        'disabled:cursor-not-allowed disabled:opacity-50',
        invalid ? 'border-danger focus-visible:border-danger focus-visible:ring-danger/40' : 'border-input',
        className,
      )}
      {...props}
    />
  );
}
